import { connect } from 'react-redux';

import CareGuidesAdminScreen from '../components/CareGuidesAdminScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    total: state.careGuides.get('total'),
    isLoading: state.careGuides.get('isLoading'),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const CareGuidesAdminScreenContainer = connect(mapStateToProps)(
  CareGuidesAdminScreen
);

export default CareGuidesAdminScreenContainer;
